import _ from 'lodash'
import backend from '../../components/utils/backend'
import { mapBody } from './fast-counter/functions'

export default {
  state: {
    preview: {
      name: '',
      config: {},
      marketCodes: []
    },
    oldState: ''
  },
  mutations: {
    'CLEAR_STATE': function (state) {
      state.preview = {
        name: '',
        config: {},
        marketCodes: []
      }
    },
    'LOAD_CONFIG': function (state, payload) {
      state.preview.config = _.cloneDeep(payload)
    },
    'LOAD_PREVIEW': function (state, payload) {
      state.preview = _.cloneDeep(payload)
    },
    'CLEAR_PREVIEW': function (state) {
      state.preview.config.preview = {}
    },
    'UPDATE_PREVIEW_CONFIG_SECTION': function (state, payload) {
      const { data, section } = payload

      state.preview.config[section] = _.cloneDeep(data)
    },
    'UPDATE_PREVIEW_FIELD': function (state, payload) {
      const { data, fieldName } = payload
      state.preview[fieldName] = _.cloneDeep(data)
    },
    'LOAD_OLD_STATE': function (state) {
      state.preview = JSON.parse(state.oldState)
    },
    'SAVE_OLD_STATE': function (state) {
      state.oldState = JSON.stringify(state.preview)
    }
  },
  actions: {
    clearState ({ commit }) {
      commit('CLEAR_STATE')
    },
    loadConfig ({ commit }, payload) {
      commit('CLEAR_STATE')
      commit('LOAD_CONFIG', payload)
    },
    async getPreviews ({ rootGetters }) {
      try {
        const response = (await backend.get(`/api/v1/fast-counter`, rootGetters['session/accessToken'])).body
        return response
      } catch (error) {
        throw error
      }
    },
    async getPreview ({ rootGetters, commit }, previewId) {
      try {
        const response = (await backend.get(`/api/v1/fast-counter/${previewId}`, rootGetters['session/accessToken'])).body
        commit('LOAD_PREVIEW', response)
        if (response.httpCode && response.httpCode === '404') {
          throw new Error(`Preview with id ${offerId} not found`)
        } else {
          return response
        }
      } catch (error) {
        throw error
      }
    },
    async getEmptyConfig({ rootGetters }) {
      try {
        const response = (await backend.get(`/api/v1/fast-counter/new/config`, rootGetters['session/accessToken'])).body
        if (response.httpCode && response.httpCode !== '200') {
          throw new Error(response)
        } else {
          return response
        }
      } catch (error) {
        throw error
      }
    },
    async getConfig ({ rootGetters }) {
      try {
        const response = (await backend.get(`/api/v1/fast-counter-query-builder-config`, rootGetters['session/accessToken'])).body
        if (response.httpCode && response.httpCode !== '200') {
          throw new Error(response)
        } else {
          return response.config
        }
      } catch (error) {
        throw error
      }
    },
    loadOldState ({ commit }) {
      commit('LOAD_OLD_STATE')
    },
    saveOldState ({ commit }) {
      commit('SAVE_OLD_STATE')
    },
    async savePreview ({ getters, commit, rootGetters }, payload) {
      try {
          const body = mapBody(getters.state.preview)

          const response = await backend.post('/api/v1/fast-counter', rootGetters['session/accessToken'], body)
          if (response.statusCode !== 201) {
            console.error('Error during save', response.body)
            throw new Error(response.body.statusMessage)
          } else {
            commit('LOAD_PREVIEW', response.body)
            return response.body
          }
        } catch (error) {
          throw error
        }
    },
    async update ({ getters, rootGetters }, payload) {
      try {
        const { previewId } = payload
        const body = mapBody(getters.state.preview)

        const response = await backend.put(`/api/v1/fast-counter/${previewId}`, rootGetters['session/accessToken'], body)
        if (response.statusCode !== 200) {
          console.error('Error during update', response.body)
          throw new Error(response.body.moreInformation)
        } else {
          return response.body
        }
      } catch (error) {
        throw error
      }
    },
    async deletePreview ({ rootGetters }, payload) {
      try {
        const { previewId } = payload
        const response = await backend.delete(`/api/v1/fast-counter/${previewId}`, rootGetters['session/accessToken'])

        if (response.statusCode !== 200) {
          console.error('Error during delete', response.body)
          throw new Error(response.body.moreInformation)
        } else {
          return response.body
        }
      } catch (error) {
        throw error
      }
    },
    updatePreviewSection ({ commit, state }, payload) {
      const { data, section, vm } = payload
      const { config, flat, userPreferences } = data

      const currentPreview = state.preview

      switch (section) {
        case 'previewData':
          // If market changed, change inherited market-based sections
          const oldMarket = JSON.stringify(currentPreview.config.previewData.markets.selected)
          const newMarket = JSON.stringify(config.markets.selected)

          // const oldBrands = JSON.stringify(currentPreview.config.previewData.brands.selected)
          // const newBrands = JSON.stringify(config.brands.selected)

          if (oldMarket !== newMarket) {
            const filters = {
              selected: currentPreview.config.targetDefinition ? currentPreview.config.targetDefinition.selected : {},
              standard: {
                id: 'item_standard',
                segmentName: vm.$t('campaignDesigner.targetDefinition.standardSegment'),
                type: 'group',
                operator: 'AND',
                conditions: [
                  {
                    field: 'cod_market',
                    operator: 'in',
                    table: 'contact',
                    type: 'rule',
                    values: config.markets.selected
                  }//,
                  // {
                  //   field: 'brand',
                  //   table: 'car',
                  //   type: 'rule',
                  //   operator: 'in',
                  //   values: config.brands.selected
                  // }
                ].flat()
              }
            }

            commit('UPDATE_PREVIEW_CONFIG_SECTION', { section: 'targetDefinition', data: _.cloneDeep(filters) })
          }
          break
      }

      if (flat) {
        Object.entries(flat).forEach(([k, v]) => {
          commit('UPDATE_PREVIEW_FIELD', { fieldName: k, data: v})
        })
      }

      if (config) {
        commit('UPDATE_PREVIEW_CONFIG_SECTION', { section, data: _.cloneDeep(config)})
        }
    },
    // Preview
    clearPreview ({ commit }) {
      commit('CLEAR_PREVIEW')
    },
    async startPreview ({ commit, dispatch, getters, rootGetters }, payload) {
      try {
        const body = {
          type: 'Preview',
          detail: {
            fastCounterId: getters.currentPreview.id,
            department: 'FAST_COUNTER'
          }
        }

        const response = (await backend.post(`/api/v1/job`, rootGetters['session/accessToken'], body)).body
        const previewObject = { section: 'preview', data: { jobId: response.id } }
        commit('UPDATE_PREVIEW_CONFIG_SECTION', previewObject)
        dispatch('update', { previewId: getters.currentPreview.id })
        return response
      } catch (error) {
        throw error
      }
    },
    async checkPreview ({ rootGetters }, payload) {
      try {
        const { jobId } = payload
        const response = (await backend.get(`/api/v1/job/${jobId}`, rootGetters['session/accessToken'])).body

        return response
      } catch (error) {
        throw error
      }
    },
    async poll ({ commit, dispatch, rootGetters }, payload) {
      try {
        const { previewId } = payload
        const preview = await dispatch('getPreview', parseInt(previewId))
        return preview.preview
      } catch (error) {
        throw error
      }
    },
  },
  getters: {
    state: state => state,
    currentPreview: state => state.preview
  },
  namespaced: true
}
